<template lang="pug">
  div logout
</template>

<script>
import auth0Service from '@/services/auth0'

export default {
  async mounted () {
    await auth0Service.logout()
    this.$router.push('/login')
  }
}
</script>
